<div class="container-fluid py-4">
  <div class="row justify-content-center mb-0">
    <div class="col column" *ngFor="let card of resumenCardsTwo; let i = index">
      <div
        class="card card-stats__two"
        [ngClass]="{ 'card-stats__two--selected': i === 2 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <h4 class="h4">(Task Runner)</h4> -->
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 5 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 5, 'text-white': i !== 5 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 5 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Campo de búsqueda mejorado con autocompletado -->

  <div class="row mb-3 mt-1">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filterTask()"
          list="suggestionsCourier"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="suggestionsCourier">
          <option
            *ngFor="let suggestion of searchSuggestions"
            [value]="suggestion"
          ></option>
        </datalist>
      </div>
    </div>
  </div>

  <div class="card-tools">
    <div class="row">
      <div class="col-12">
        <a class="btn btn-dark btn-sm btn-fees" [routerLink]="['/logistics/fees/task']">
          Customer Charges
        </a>
        <a
          [routerLink]="['/logistics/fees/driverEmm']"
          class="btn btn-dark btn-sm btn-new"
        >
          Driver Fees
        </a>
        <a [routerLink]="['/logistics/fees/emm/add']" class="btn btn-dark btn-sm btn-new">
          Add item
        </a>
      </div>
      <!-- <div class="col-6">
          <h2><strong>CUSTOMER CHARGES</strong></h2>
        </div> -->
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Name</th>
              <th>Value</th>
              <th class="th__status">Status</th>
              <th class="th__status">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td>{{ item.name }}</td>
              <td>{{ item.value }}</td>
              <td>
                <span
                  class="badge span__badge"
                  [ngClass]="item.status ? 'badge-success' : 'badge-danger'"
                >
                  {{ item.status ? "Active" : "Inactive" }}
                </span>
              </td>
              <td>
                <a
                  class="btn btn-link text-dark btn-sm btn-del"
                  routerLink="/fees/task/edit/{{ item._id }}"
                  ><i class="fas fa-pen"></i
                ></a>
                <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-dark btn-sm btn-del"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
